export default function(precision) {

    this._options.tweenPrecision = precision;

    return this;
};
